import { MGMAuth } from '@mgmresorts/mgm-auth-js-sdk';

import { getRedirectUrl } from '../../hooks/useAppRedirect';

export const authWithRedirect = async (
  username: string,
  password: string,
  mgmAuth: MGMAuth,
  successCallback: () => Promise<void>,
  failureCallback: () => void,
) => {
  const result = await mgmAuth.getAuthClient().signInWithCredentials({
    username,
    password,
    sendFingerprint: true,
  });

  if (result.status !== 'SUCCESS') {
    failureCallback();
    return;
  }

  await successCallback();

  const redirect = getRedirectUrl();

  mgmAuth.getAuthClient().session.setCookieAndRedirect(result.sessionToken, redirect);
};
